import { render, staticRenderFns } from "./HighlightAccountsToggle.vue?vue&type=template&id=125c3466"
import script from "./HighlightAccountsToggle.vue?vue&type=script&lang=ts"
export * from "./HighlightAccountsToggle.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports